import { EventProductMappedToTier } from 'legacy/common/types/models';
import TierCard from './components/TierCard';

type Props = {
  title?: React.ReactNode;
  tiers: EventProductMappedToTier[];
  id: string;
};

const TierCategory = ({ title, tiers, id }: Props) => (
  <div
    id={`${id}-section`}
    className="px-4 not-first:border-t-2 md:border-t-0! border-neutral-200 pb-6 md:pb-11 gap-5 flex flex-col md:max-w-[650px] pt-6"
  >
    {title && (
      <h3 className="text-neutral-900 text-lg font-bold flex items-center gap-1.5">
        {title}
      </h3>
    )}
    <ul className="flex flex-col gap-5">
      {tiers.map((tier) => (
        <li key={tier._id}>
          <TierCard tier={tier} />
        </li>
      ))}
    </ul>
  </div>
);

export default TierCategory;
